{
  "count": "8",
  "display_name": "Andre",
  "institution_name": "Chase Bank",
  "staging_url": "https://dev.hearthfire.ai/integrations/staging"
}
